import { GitHubConnectMethod } from '@neo.tax/shared/enums';
import { ProviderType } from '@neo.tax/shared/graphql';

import { DeterministicProvider } from '../connect-account-modal/SelectProviders';
import { ConnectProviderSlide } from './connect-provider-slide';
import { ConnectProviderSlideProps } from './connect-provider-slide/slides';

/**
 * @deprecated instead cleanup downstream code to use the providerType directly
 */
const getSlideProviderType = (providerType: ProviderType): 'accounting' | 'payroll' | 'ticketing' => {
  switch (providerType) {
    case ProviderType.Accounting:
      return 'accounting';
    case ProviderType.Payroll:
      return 'payroll';
    case ProviderType.Ticketing:
      return 'ticketing';
    case ProviderType.PayrollMonthExpenses:
      throw new Error('ASC Cost is not supported');
  }
};

export const ConnectProviders = ({
  close,
  fiscalYearId,
  initialGitHubConnectMethod,
  initialOrganizationSlug,
  restart,
  selectedProvider,
}: {
  fiscalYearId: string;
  selectedProvider: DeterministicProvider;
  close: () => void;
  restart: () => void;
  /** Skips GitHub's method-choice step; see ConnectGitHub's `initialMethod`. */
  initialGitHubConnectMethod?: GitHubConnectMethod | null;
  /** The organization a resumed or reconnected GitHub App connection is already for. */
  initialOrganizationSlug?: string | null;
}): React.ReactElement => {
  // TODO remove this transformation and cleanup the downstream code
  const transformedSelectedProvider = {
    providerName: selectedProvider.provider,
    providerType: getSlideProviderType(selectedProvider.providerType),
  } as ConnectProviderSlideProps['provider'];

  return (
    <ConnectProviderSlide
      fiscalYearId={fiscalYearId}
      close={close}
      restart={restart}
      provider={transformedSelectedProvider}
      initialGitHubConnectMethod={initialGitHubConnectMethod}
      initialOrganizationSlug={initialOrganizationSlug}
    />
  );
};
